<template>
  <vs-popup id="popupAccount" title="" :active.sync="showPopup">
    <div class="grid text-center">
      <span class="m-2" style="font-size: 24px; font-weight: 500;">{{ title }}</span>
      <span class="m-2" style="font-size: 15px; font-weight: 400;">{{ message }}</span>
      <span v-if="isReason" class="m-2" style="font-size: 15px; font-weight: 500;">거절사유</span>
      <span class="m-2" style="font-size: 15px; font-weight: 400;">{{ reason }}</span>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: "PopupAccountAlert",
  props: {
    value: Boolean,
    title: String,
    message: String,
    isReason: Boolean,
    reason: String,
  },
  watch: {
    value(data) {
      this.showPopup = data;
    },
    showPopup(data) {
      this.$emit("input", data);
    },
  },
  data() {
    return {
      showPopup: false,
    }
  },
}
</script>

<style lang="scss">
#popupCompany.con-vs-popup {
  z-index: 53000;

  .vs-popup {
    width: 35%;
    height: auto;

    position: relative;
  }
  .vs-popup--content {
    width: auto !important;
    padding: 1rem;
    font-size: 1rem;
  }
}
</style>
